import { render } from "./ExploreActiveIcon.vue?vue&type=template&id=7978e6c8"
import script from "./ExploreActiveIcon.vue?vue&type=script&lang=js"
export * from "./ExploreActiveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__